import {
  COUPON_STATUS,
  PREFERENTIAL_MODE_DECREASE,
  PREFERENTIAL_MODE_DISCOUNT,
} from "@/constants/coupon";
import { getCounpons } from "@/services";
import formatTime from "@/utils/formatTime";
import { getDiffDays } from "@/utils/time";
import classNames from "classnames";
import { round } from "lodash";
import VipRadio from "../vipCheckbox/radio";
import styles from "./index.module.less";

export default function TicketList({ selected, list, onChange }) {
  return (
    <div className={styles.couponList}>
      <div className={styles.title}>可用优惠券</div>
      <div
        className={classNames(styles.nonuse, {
          [styles.active]: !selected?.length,
        })}
        onClick={() => onChange([])}
      >
        <span>不使用优惠券</span>{" "}
        <VipRadio checked={!selected?.length} size="middle" />
      </div>
      {list.map((t) => (
        <TicketCard
          active={selected && selected.map((s) => s.id).includes(t.id)}
          ticket={t}
          key={t.id}
          onClick={() => {
            onChange([t]);
          }}
        />
      ))}
    </div>
  );
}

export function TicketCard({ ticket, active, onClick }) {
  return (
    <div
      className={classNames(styles.ticketCard, { [styles.active]: active })}
      onClick={onClick}
    >
      <div className={styles.preferential}>
        {/* 直接减 */}
        {ticket.preferential_mode === PREFERENTIAL_MODE_DECREASE && (
          <div>
            <span>
              ￥
              <span className={styles.value}>{ticket.preferential_value}</span>
            </span>
          </div>
        )}
        {/* 打折 */}
        {ticket.preferential_mode === PREFERENTIAL_MODE_DISCOUNT && (
          <div>
            <span>
              <span className={styles.value}>{ticket.preferential_value}</span>
              折
            </span>
          </div>
        )}
        <span>
          {ticket.threshold_amount === 0
            ? "无门槛"
            : `满${ticket.threshold_amount}可用`}
        </span>
      </div>

      <div className={styles.info}>
        <div>{ticket.name}</div>
        <div className={styles.time}>
          {formatTime(ticket.valid_end_time, "YYYY/MM/DD HH:mm")}到期
        </div>
      </div>

      <div>
        <VipRadio checked={active} size="middle" />
      </div>
    </div>
  );
}
// 获取能用的优惠券
export async function getMatchedCoupons(details, payPrice) {
  const { list: tickets, err } = await getCounpons({
    status: COUPON_STATUS.GOT,
    page_num: 1,
    page_size: 100,
  });
  if (err) {
    return [];
  }

  let filter = tickets
    .filter((t) => getDiffDays(t.valid_start_time, Date.now()) <= 0)
    // 匹配支持满减的
    .filter((t) => payPrice >= t.threshold_amount)
    // 匹配商品符合的
    .filter((t) => {
      const ranges = t.applicable_ranges;
      // 未指明商品的
      if (!ranges || ranges.length === 0) {
        return true;
      }

      return (
        details
          // 过滤掉没有sku的非商品信息
          .filter((d) => d.skuId)
          // 购买的A、B、C商品必须全部可以使用该券
          .every((d) => {
            // sku匹配模式
            if (
              ranges.find((r) => r.target_type === "SKU" && r.sku_id == d.skuId)
            ) {
              return true;
            }
            // 商品匹配模式
            if (
              ranges.find(
                (r) => r.target_type === "GOODS" && r.goods_id == d.good?.id
              )
            ) {
              return true;
            }

            return false;
          })
      );
    });

  // 计算折抵金额，根据金额进行从大到小排序，默认选中最大的
  filter.forEach((t) => {
    if (t.preferential_mode === PREFERENTIAL_MODE_DECREASE) {
      // 直接金额优惠
      t.discount = t.preferential_value;
    } else {
      // 打折优惠
      // 计算打折后金额
      t.discount = round(((10 - t.preferential_value) * payPrice) / 10, 2);
      // 打折最大金额
      if (t.max_discount_amount) {
        t.discount = Math.min(t.max_discount_amount, t.discount);
      }
    }
  });

  filter.sort((a, b) => b.discount - a.discount);

  return filter;
}
